import type {SxProp} from '@primer/styled-react'
import {Text} from '@primer/styled-react'
import {clsx} from 'clsx'
import {use, useEffect} from 'react'
import {getNodeText} from '../shared'
import ChartCardContext from './context'

import styles from './Description.module.css'

export type DescriptionProps = {
  children: React.ReactNode
  className?: string
} & SxProp

const Description = ({sx, children, className}: DescriptionProps) => {
  const {setDescription, size} = use(ChartCardContext)
  useEffect(() => {
    setDescription(getNodeText(children))
  }, [setDescription, children])
  return size !== 'sparkline' ? (
    <Text sx={sx} className={clsx(className, styles.ChartCardDescriptionText)}>
      {children}
    </Text>
  ) : null
}

export default Description
